import React from 'react';
import { pickFunction } from 'Helpers/Affordances';
import fr from 'facet-rest';
import RelationshipExists from './RelationshipExists';

const OutcomeInsightPicker = ({
  resource,
}) => {
  return pickFunction(resource, {
    [fr.relationships.insights.name]: () => {
      return (
        <RelationshipExists
          resource={resource}
        />
      );
    },
    [fr.relationships.default.name]: () => null,
  });
};

export default OutcomeInsightPicker;
